import React from "react";
import { Link, HStack, Text } from "@chakra-ui/react";

// Bouton « Ajouter aux sources préférées » de Google.
//
// ⚠️ Composant DUPLIQUÉ à l'identique dans `next-app/components/` — même
// convention que `imageSeo.js` et `titleSuggestion.js` : il n'y a pas de paquet
// partagé entre les briques. Toute évolution se fait aux deux endroits.
//
// L'utilisateur qui clique désigne 9achna comme source de confiance dans SA
// recherche Google. Le site est alors marqué comme préféré dans Top Stories et,
// depuis mai 2026, dans AI Mode et les AI Overviews. C'est le seul levier de
// visibilité qui ne dépend ni du classement ni de l'autorité du domaine : il se
// gagne auprès des visiteurs déjà acquis.
//
// La cible est le DOMAINE : Google n'accepte que les domaines et sous-domaines
// dans cet outil, jamais un sous-répertoire.
const PREFERRED_SOURCE_URL = "https://google.com/preferences/source?q=9achna.com";

// Logo Google officiel — nécessaire pour que le bouton soit reconnu.
// Google autorise explicitement un visuel maison à côté de ses propres
// ressources téléchargeables.
function GoogleG({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
      <path fill="#4285F4" d="M23.745 12.27c0-.7-.06-1.4-.19-2.07H12v3.92h6.61c-.29 1.5-1.14 2.77-2.4 3.63v3h3.86c2.26-2.09 3.67-5.17 3.67-8.48z" />
      <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.1A11.97 11.97 0 0 0 12 24z" />
      <path fill="#FBBC05" d="M5.27 14.29a7.18 7.18 0 0 1 0-4.58V6.61H1.29a11.94 11.94 0 0 0 0 10.78l3.98-3.1z" />
      <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.44-3.44A11.93 11.93 0 0 0 1.29 6.61l3.98 3.1c.95-2.85 3.6-4.96 6.73-4.96z" />
    </svg>
  );
}

export default function PreferredSourceButton({ compact = true }) {
  return (
    <Link
      href={PREFERRED_SOURCE_URL}
      isExternal
      rel="noopener noreferrer"
      title="Marquer 9achna comme source préférée dans votre recherche Google"
      _hover={{ textDecoration: "none", bg: "#f8faff", boxShadow: "sm" }}
      bg="white"
      border="1px solid"
      borderColor="#dadce0"
      borderRadius="full"
      boxShadow="0 1px 3px rgba(0,0,0,0.08)"
      px={compact ? 3.5 : 5}
      py={compact ? 1.5 : 2.5}
      transition="all 0.2s"
      display="inline-flex"
    >
      <HStack spacing={2}>
        <GoogleG size={compact ? 14 : 18} />
        <Text
          fontSize={compact ? "xs" : "15px"}
          fontWeight="500"
          color="#1a73e8"
          whiteSpace="nowrap"
        >
          Ajouter aux sources préférées
        </Text>
      </HStack>
    </Link>
  );
}
